import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=b4c7144c&"
import script from "./ReviewPage.vue?vue&type=script&lang=js&"
export * from "./ReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports